// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
  height: 100%;
  display: block;
}

.image-container {
  padding: 0.375rem 0.375rem 0.75rem;
  background-color: var(--ion-color-light);
  margin: 0;
  border-radius: 0.25rem;
  height: 100%;
}
.image-container::ng-deep .carousel-container .carousel-wrapper {
  cursor: default;
}
.image-container::ng-deep .carousel-container .carousel-item {
  position: relative;
}
.image-container::ng-deep .carousel-container .carousel-item .banner-image {
  background-color: var(--ion-color-light);
}
.image-container::ng-deep .carousel-container .categorybar__scrollbutton {
  display: none;
}
.image-container::ng-deep .carousel-container .indicators {
  top: 8.125rem;
  bottom: unset;
}
.image-container .promo-image {
  width: 100%;
  height: 7.06rem;
  object-fit: cover;
}
.image-container .name {
  margin: 2.5rem 0 2.31rem;
  text-align: center;
}
.image-container .details {
  position: absolute;
  bottom: 0.169rem;
  right: 0.925rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.17rem;
  text-align: left;
  color: #333333;
  text-decoration: underline;
}

@media screen and (min-width: 751px) and (max-width: 991px) {
  .image-container .promo-image {
    height: calc((100vw - 40px) / 2.7) !important;
  }
  .image-container::ng-deep .carousel-container .indicators {
    top: calc((100vw - 40px) / 2.7 + 0.75rem) !important;
  }
}
@media screen and (max-width: 991px) {
  .image-container {
    padding: 0.25rem 0.25rem 0.5rem;
  }
  .image-container .promo-image {
    height: calc((100vw - 40px) / 2.34);
  }
  .image-container::ng-deep .carousel-container .indicators {
    top: calc((100vw - 40px) / 2.34 + 0.75rem);
  }
  .image-container .name {
    margin: 1.75rem 0 1.625rem;
  }
  .image-container .details {
    font-size: 0.688rem;
    line-height: 0.81rem;
    bottom: 0.125rem;
    right: 0.625rem;
  }
}
@media screen and (max-width: 575px) {
  .image-container {
    padding: 0.25rem 0.25rem 0.25rem;
  }
  .image-container .name {
    margin-top: 1.5rem;
    margin-bottom: 0.25rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/player-dashboard/promotions-section/promotions-section.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,cAAA;AACJ;;AAEA;EACI,kCAAA;EACA,wCAAA;EACA,SAAA;EACA,sBAAA;EACA,YAAA;AACJ;AAEQ;EACI,eAAA;AAAZ;AAGQ;EACI,kBAAA;AADZ;AAGY;EACI,wCAAA;AADhB;AAKQ;EACI,aAAA;AAHZ;AAMQ;EACI,aAAA;EACA,aAAA;AAJZ;AAQI;EACI,WAAA;EACA,eAAA;EACA,iBAAA;AANR;AASI;EACI,wBAAA;EACA,kBAAA;AAPR;AAUI;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;AARR;;AAaA;EAEQ;IACI,6CAAA;EAXV;EAeU;IACI,oDAAA;EAbd;AACF;AAkBA;EACI;IACI,+BAAA;EAhBN;EAkBM;IACI,mCAAA;EAhBV;EAoBU;IACI,0CAAA;EAlBd;EAsBM;IACI,0BAAA;EApBV;EAuBM;IACI,mBAAA;IACA,oBAAA;IACA,gBAAA;IACA,eAAA;EArBV;AACF;AAyBA;EACI;IACI,gCAAA;EAvBN;EAyBM;IACI,kBAAA;IACA,sBAAA;EAvBV;AACF","sourcesContent":[":host {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: block;\r\n}\r\n\r\n.image-container {\r\n    padding: 0.375rem 0.375rem 0.75rem;\r\n    background-color: var(--ion-color-light);\r\n    margin: 0;\r\n    border-radius: 0.25rem;\r\n    height: 100%;\r\n\r\n    &::ng-deep .carousel-container {\r\n        .carousel-wrapper {\r\n            cursor: default;\r\n        }\r\n\r\n        .carousel-item {\r\n            position: relative;\r\n\r\n            .banner-image {\r\n                background-color: var(--ion-color-light);\r\n            }\r\n        }\r\n\r\n        .categorybar__scrollbutton {\r\n            display: none;\r\n        }\r\n\r\n        .indicators {\r\n            top: 8.125rem;\r\n            bottom: unset;\r\n        }\r\n    }\r\n\r\n    .promo-image {\r\n        width: 100%;\r\n        height: 7.06rem;\r\n        object-fit: cover;\r\n    }\r\n\r\n    .name {\r\n        margin: 2.5rem 0 2.31rem;\r\n        text-align: center;\r\n    }\r\n\r\n    .details {\r\n        position: absolute;\r\n        bottom: 0.169rem;\r\n        right: 0.925rem;\r\n        font-size: 1rem;\r\n        font-weight: 400;\r\n        line-height: 1.17rem;\r\n        text-align: left;\r\n        color: #333333;\r\n        text-decoration: underline;\r\n    }\r\n}\r\n\r\n\r\n@media screen and (min-width: 751px) and (max-width: 991px) {\r\n    .image-container {\r\n        .promo-image {\r\n            height: calc((100vw - 40px) / 2.7) !important;\r\n        }\r\n\r\n        &::ng-deep .carousel-container {\r\n            .indicators {\r\n                top: calc((100vw - 40px) / 2.7 + 0.75rem) !important;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n    .image-container {\r\n        padding: 0.25rem 0.25rem 0.5rem;\r\n\r\n        .promo-image {\r\n            height: calc((100vw - 40px) / 2.34);\r\n        }\r\n\r\n        &::ng-deep .carousel-container {\r\n            .indicators {\r\n                top: calc((100vw - 40px) / 2.34 + 0.75rem);\r\n            }\r\n        }\r\n\r\n        .name {\r\n            margin: 1.75rem 0 1.625rem;\r\n        }\r\n\r\n        .details {\r\n            font-size: 0.688rem;\r\n            line-height: 0.81rem;\r\n            bottom: 0.125rem;\r\n            right: 0.625rem;\r\n        }\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 575px) {\r\n    .image-container {\r\n        padding: 0.25rem 0.25rem 0.25rem;\r\n\r\n        .name {\r\n            margin-top: 1.5rem;\r\n            margin-bottom: 0.25rem;\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
